import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import BaseClickable from 'components/ui/BaseClickable';
import { BurgerIcon } from 'components/ui/icons/BurgerIcon';
import { accessibilityParamsStore } from 'stores/root';

import s from './MenuButton.module.scss';

type MenuButtonProps = {
  onClick: VoidFunction;
};

const MenuButton: React.FC<MenuButtonProps> = ({ onClick }) => {
  const { isOpen: isAccessibilityMode } = accessibilityParamsStore;

  return (
    <BaseClickable
      className={cn(s.root, isAccessibilityMode && s.root_accessibility)}
      onClick={onClick}
      data-test-id="menu-button"
    >
      <BurgerIcon className={s.root__icon} />
    </BaseClickable>
  );
};

export default observer(MenuButton);
